import { Button } from '@fl/cmsch-fe-library';
import { isNonEmpty } from 'fp-ts/Array';
import React, { FC, useCallback } from 'react';
import { BreederRoleManagement } from 'api/gen/BreederRoleManagement';
import { useOurTranslation } from 'app/translations';
interface Props {
  /** Source breeder-role row. */
  role: BreederRoleManagement;
  /** Builds the tooltip text for the farm list. */
  computeFarmsTooltip(ids: Array<number>): string;
  /** Callback invoked when the action is clicked. */
  onCellClick(role: BreederRoleManagement): void;
}

/**
 * Renders a clickable breeder-management table action.
 *
 * @param props Breeder row, tooltip builder, and click callback.
 * @returns Clickable breeder-management table action.
 */
export const DynamicContent: FC<Props> = ({
  role,
  computeFarmsTooltip,
  onCellClick
}) => {
  const handleCellClick = useCallback((): void => {
    onCellClick(role);
  }, [onCellClick, role]);
  const {
    t
  } = useOurTranslation('userDetail');
  const {
    hasAccessToAllFarms,
    farmIds
  } = role;
  if (hasAccessToAllFarms) {
    return <Button icon="greenCheckCircleFilled" visuals="text" block tooltip={t('allFarms')} onClick={handleCellClick} />;
  }
  if (farmIds && isNonEmpty(farmIds)) {
    return <Button icon="threeDotsCircle" visuals="text" tooltip={computeFarmsTooltip(farmIds)} block onClick={handleCellClick} />;
  }
  return <span data-sentry-component="DynamicContent" data-sentry-source-file="gen-dynamic-content.tsx" />;
};